import React from "react";
import { Button } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import PageHeader from "../../shared/components/PageHeader";

// Page-header definition for the legacy v1 student-detail pages. The student's
// name is the title, the per-student section menu (Account, Profile, Medical,
// ...) becomes the header tabs, and the "Return to Student List" link is the only
// action. The tab set is permission-gated v1-side and handed over as plain data;
// navigation routes through onNavigate (which preserves v1's param-carrying tab
// logic) and onReturnToList, so the inert MemoryRouter is never used to navigate.
export default function StudentInfoHeader({
  studentName,
  tabs = [],
  activeKey,
  onNavigate,
  onReturnToList,
}) {
  return (
    <PageHeader
      title={studentName || "Loading..."}
      tabs={tabs.map((t) => ({
        key: t.key,
        label: t.label,
        onClick: () => onNavigate(t.url),
      }))}
      activeTab={activeKey}
      actions={
        <Button
          onClick={onReturnToList}
          startIcon={<ArrowBackRoundedIcon />}
          size="small"
          sx={{ flexShrink: 0, whiteSpace: "nowrap", textTransform: "none" }}
        >
          Return to Student List
        </Button>
      }
    />
  );
}
